import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Idea,FileService, CacheService } from 'mapfre-auditlib';
import { map, mergeMap } from 'rxjs/operators';
import { Observable, forkJoin } from 'rxjs';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class IdeaService {

  className = 'IdeaService'

  constructor(private http: HttpClient,private fileService: FileService, private cacheService: CacheService) { }

  getAllIdeas(cache = true, cacheKey = "allIdeas"): Observable<Idea[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<Idea[]>(environment.base_URL + "/ideas").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getIdeaById(id): Observable<any> {
    let params:any = {};
    params.ideaId = id;
    return this.http.get(environment.base_URL + "/ideas",{params}).pipe(map(res => {return res[0]}));    
  }

  newIdea(label) {
    return this.http.post(environment.base_URL + "/ideas", label);
  }

  newIdeaWithFiles(label){
     // PRE FILES INI
     let filesToUpload = _.remove(_.get(label, 'fileNames'), (f) => f instanceof File);
     // PRE FILES END
     //CHECK IF THERE ARE NEW FILES
     if (!_.isEmpty(filesToUpload)) {
       return this.newIdea(label).pipe(mergeMap((res: any) => {
         let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'idea', res));
         return forkJoin(observables).pipe(map(resultFiles => {
           return res;
         }));
       }))
     }
     else {
       return this.newIdea(label)
     }
  }

  updateIdea(id, idea) {
    return this.http.put(environment.base_URL + `/ideas/${id}`, idea)
  }

  updateIdeaWithFiles(id,idea){
    // PRE FILES INI
    let filesToUpload = _.remove(_.get(idea, 'fileNames'), (f) => f instanceof File);
    // PRE FILES END
    //CHECK IF THERE ARE NEW FILES
    if (!_.isEmpty(filesToUpload)) {
      return this. updateIdea(id, idea).pipe(mergeMap((res: any) => {
        let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'idea', res));
        return forkJoin(observables).pipe(map(resultFiles => {
          return res;
        }));
      }))
    }
    else {
      return this. updateIdea(id, idea)
    }
 }

  deleteIdea(id: Number) {
    return this.http.delete(environment.base_URL + `/ideas/${id}`)
  }
}